export const colors = {
  primary: '#ADFCF1',
  secondary: '#FF6722',
  textPrimary: '#FF6722',
  buttonBackground: '#FFAF97',
  darkPink: '#D87A5F',
  greyText: 'rgba(185,190,209,1)',
  greyLight: 'rgba(227,232,240,1)',
};
